module.exports = __webpack_public_path__ + "static/media/Doctor_male.87c90fac.png";